import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const ArrowsUpDownNotRound24 = (props: SvgIconProps): JSX.Element => React.createElement(
    SvgIcon,
    props,
    <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><g fillRule='evenodd' clipRule='evenodd'><path d='M11.057 1.724c.52-.52 1.365-.52 1.886 0l5.333 5.333-1.886 1.886L12 4.553l-4.39 4.39-1.886-1.886 5.333-5.333Z' /><path d='M11.057 22.276c.52.52 1.365.52 1.886 0l5.333-5.333-1.886-1.886-4.39 4.39-4.39-4.39-1.886 1.886 5.333 5.333Z' /></g></svg>,
);
